import {
  getGetBackAttivitaCsvQueryOptions,
  getGetBackAttivitaXlsxQueryOptions,
  getGetBackProcedimentiCsvCampiQueryOptions,
  getGetBackProcedimentiCsvQueryOptions,
  getGetBackProcedimentiGeojsonCampiQueryOptions,
  getGetBackProcedimentiGeojsonQueryOptions,
  getGetBackProcedimentiXlsxQueryOptions,
  getGetFrontRichiesteCsvCampiQueryOptions,
  getGetFrontRichiesteCsvQueryOptions,
  getGetFrontRichiesteGeojsonCampiQueryOptions,
  getGetFrontRichiesteGeojsonQueryOptions,
  getGetVersioniProcedimentoIdCampiCsvQueryOptions,
  getGetVersioniProcedimentoIdCampiGeojsonQueryOptions,
  useGetBackProcedimentiCsvCampi,
  useGetBackProcedimentiGeojsonCampi,
} from '@framework/api-client';

export const ExportableFileTypes = {
  csv: {
    type: 'csv',
    label: 'CSV',
    extension: 'csv',
    storageKey: 'csv',
    getGetVersioniProcedimentoIdCampiFileQueryOptions:
      getGetVersioniProcedimentoIdCampiCsvQueryOptions,
    getGetBackProcedimentiFileQueryOptions:
      getGetBackProcedimentiCsvQueryOptions,
    useGetBackProcedimentiFileCampi: useGetBackProcedimentiCsvCampi,
    getGetBackProcedimentiFileCampiQueryOptions:
      getGetBackProcedimentiCsvCampiQueryOptions,
    getGetFrontRichiesteFileQueryOptions: getGetFrontRichiesteCsvQueryOptions,
    getGetFrontRichiesteFileCampiQueryOptions:
      getGetFrontRichiesteCsvCampiQueryOptions,
    getBackAttivitaFileQueryOptions: getGetBackAttivitaCsvQueryOptions,
  },
  xlsx: {
    type: 'xlsx',
    label: 'XLSX',
    extension: 'xlsx',
    getGetVersioniProcedimentoIdCampiFileQueryOptions:
      getGetVersioniProcedimentoIdCampiCsvQueryOptions,
    getGetBackProcedimentiFileQueryOptions:
      getGetBackProcedimentiXlsxQueryOptions,
    useGetBackProcedimentiFileCampi: useGetBackProcedimentiCsvCampi,
    getGetBackProcedimentiFileCampiQueryOptions:
      getGetBackProcedimentiCsvCampiQueryOptions,
    getGetFrontRichiesteFileQueryOptions: getGetFrontRichiesteCsvQueryOptions,
    getGetFrontRichiesteFileCampiQueryOptions:
      getGetFrontRichiesteCsvCampiQueryOptions,
    getBackAttivitaFileQueryOptions: getGetBackAttivitaXlsxQueryOptions,
  },
  geojson: {
    type: 'geojson',
    label: 'GeoJSON',
    extension: 'json',
    getGetVersioniProcedimentoIdCampiFileQueryOptions:
      getGetVersioniProcedimentoIdCampiGeojsonQueryOptions,
    getGetBackProcedimentiFileQueryOptions:
      getGetBackProcedimentiGeojsonQueryOptions,
    useGetBackProcedimentiFileCampi: useGetBackProcedimentiGeojsonCampi,
    getGetBackProcedimentiFileCampiQueryOptions:
      getGetBackProcedimentiGeojsonCampiQueryOptions,
    getGetFrontRichiesteFileQueryOptions:
      getGetFrontRichiesteGeojsonQueryOptions,
    getGetFrontRichiesteFileCampiQueryOptions:
      getGetFrontRichiesteGeojsonCampiQueryOptions,
    getBackAttivitaFileQueryOptions: getGetBackAttivitaXlsxQueryOptions,
  },
} as const;

export type ExportableFileType =
  (typeof ExportableFileTypes)[keyof typeof ExportableFileTypes];
